import type { FC, InputHTMLAttributes } from 'react';
import { Checkbox, Form, InputNumber, Tooltip } from 'antd';
import { IMaskInput } from 'react-imask';
import styles from './style.module.css';
const DEFAULT_REGISTRATION_TIME = '00:00:00';
const TIME_INPUT_TOOLTIP = 'Введите время в формате часы : минуты : секунды';
const getTimeValidationRules = () => [
  {
    validator: (_: unknown, value?: string) =>
      !value || /^\d{2}:\d{2}:\d{2}$/.test(value)
        ? Promise.resolve()
        : Promise.reject(new Error('Укажите время в формате HH:MM:SS')),
  },
];
type TimeMaskInputProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'defaultValue' | 'onChange' | 'value'
> & {
  value?: string;
  onChange?: (value: string) => void;
};

const TimeMaskInput: FC<TimeMaskInputProps> = ({
  className,
  onChange,
  value,
  ...props
}) => (
  <IMaskInput
    {...props}
    className={['ant-input', styles.timeInput, className]
      .filter(Boolean)
      .join(' ')}
    lazy={false}
    mask="00:00:00"
    overwrite
    placeholder="00:00:00"
    placeholderChar="0"
    unmask={false}
    value={value ?? DEFAULT_REGISTRATION_TIME}
    onAccept={(nextValue: unknown) => {
      if (typeof nextValue === 'string') {
        onChange?.(nextValue);
      }
    }}
  />
);

const createTimeLabel = (label: string) => (
  <Tooltip title={TIME_INPUT_TOOLTIP}>
    <span className={styles.timeLabel}>{label}</span>
  </Tooltip>
);

export const SIPAccountRegistrationFields = () => (
  <div className={styles.panelContent}>
    <div className={styles.formGrid}>
      <Form.Item
        name="expiry"
        label={createTimeLabel('Время жизни регистрации')}
        className={styles.fieldItem}
        rules={getTimeValidationRules()}
      >
        <TimeMaskInput aria-label="Время жизни регистрации" />
      </Form.Item>
      <Form.Item
        name="registrationTimeout"
        label={createTimeLabel('Таймаут регистрации')}
        className={styles.fieldItem}
        rules={getTimeValidationRules()}
      >
        <TimeMaskInput aria-label="Таймаут регистрации" />
      </Form.Item>
      <Form.Item
        name="failureRetryInterval"
        label={createTimeLabel('Интервал повторной попытки')}
        className={styles.fieldItem}
        rules={getTimeValidationRules()}
      >
        <TimeMaskInput aria-label="Интервал повторной попытки" />
      </Form.Item>
      <Form.Item
        name="maxRegisterAttempts"
        label="Максимум попыток регистрации"
        className={styles.fieldItem}
      >
        <InputNumber
          className={styles.numberInput}
          controls
          min={1}
          placeholder="3"
          step={1}
        />
      </Form.Item>
      <Form.Item
        name="registerEnabled"
        valuePropName="checked"
        className={styles.defaultField}
        rules={[{ type: 'boolean' }]}
      >
        <Checkbox id="registerEnabled">Включить регистрацию</Checkbox>
      </Form.Item>
      <Form.Item
        name="exitOnUnequivocalFailure"
        valuePropName="checked"
        className={styles.defaultField}
        rules={[{ type: 'boolean' }]}
      >
        <Checkbox id="exitOnUnequivocalFailure">
          Остановка при фатальной ошибке
        </Checkbox>
      </Form.Item>
    </div>
  </div>
);
